import { render, staticRenderFns } from "./EmployeeTabFiles.vue?vue&type=template&id=3445cd53&scoped=true&"
import script from "./EmployeeTabFiles.vue?vue&type=script&lang=js&"
export * from "./EmployeeTabFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3445cd53",
  null
  
)

export default component.exports